import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
import {getEndOfMonth} from "@helpers/HelperFunc";

const currentYear = getEndOfMonth('year');

const BG = {
	content: `
	  <div>
		СуперХостинг.БГ пази Вашите лични данни в съответствие с <a href="` + getInitialMeta('siteURL') + `web-hosting-page-privacy-policy.php" title="Общ регламент">
		Общия регламент за защита на личните данни (GDPR)</a>.
		<br/>
		При възникване на спор, който не може да бъде решен съвместно със СуперХостинг.БГ, може да се обърнете към <a href="https://kzp.bg" rel="nofollow" target="_blank">Комисията за защита на потребителите</a> или към някой от <a href="https://consumer-redress.ec.europa.eu/dispute-resolution-bodies_en?page=2" rel="nofollow" target="_blank">органите за алтернативно решаване на спорове (АСР)</a>.
	  </div>
	
	<div>
		Всички права запазени © 2005-` + currentYear + ` за СуперХостинг.БГ ЕООД съгласно <a href="` + getInitialMeta('siteURL') + `web-hosting-page-terms-and-agreements.php" title="Общи условия">
		Общите условия за ползване</a>.
	</div>
	`
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	content: `
	  <div>
		SuperHosting.BG is fully compliant with the <a href="` + getInitialMeta('siteURL') + `web-hosting-page-privacy-policy.php" title="Privacy policy">General Data Protection Regulation (GDPR)</a>.
		<br/>
		If a dispute arises that cannot be resolved directly with SuperHosting.BG, you can use the <a href="https://kzp.bg/en" rel="nofollow" target="_blank">ODR</a> platform or contact one of the <a href="https://consumer-redress.ec.europa.eu/dispute-resolution-bodies_en?page=2" rel="nofollow" target="_blank">Alternative Dispute Resolution (ADR) bodies</a>.
	  </div>
	
	<div>
		© 2005-` + currentYear + ` SuperHosting.BG Ltd. All rights reserved <a href="` + getInitialMeta('siteURL') + `web-hosting-page-terms-and-agreements.php" title="Terms & Conditions">
		Terms & Conditions</a>.
	</div>
	`
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];